import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useToast } from '@/components/ui'
import { tenantService } from '@/services/http/tenantService'

export const useGetAIUsage = (
  tennantId: string,
  startDate?: string,
  endDate?: string,
) => {
  const { toast } = useToast()

  const { data, isError, isLoading, refetch } = useQuery({
    queryKey: ['ai-usage', tennantId, startDate, endDate],
    queryFn: () => tenantService.getAIUsage({ tennantId, startDate, endDate }),
    enabled:
      (!!tennantId && !!startDate && !!endDate) || (!startDate && !endDate),
  })

  useEffect(() => {
    if (isError)
      toast({
        title: 'Erro ao buscar dados de uso de IA',
        variant: 'destructive',
      })
  }, [isError, toast])

  return {
    aiUsageData: data?.usage,
    isLoading,
    refetchAIUsage: refetch,
  }
}
